import React from 'react';
import { Box, VStack, HStack, Text, useColorModeValue } from '@chakra-ui/react';

const DATE_LABELS = {
  appraisalOrderedDate: 'Appraisal Ordered',
  appraisalDeliveryDate: 'Appraisal Delivered',
  titleOrderedDate: 'Title Ordered',
  titleReceivedDate: 'Title Received',
  hoiOrderedDate: 'HOI Ordered',
  hoiReceivedDate: 'HOI Received',
  initialLESentDate: 'LE Sent',
  initialLESignedDate: 'LE Signed',
  initialCDSentDate: 'CD Sent',
  initialCDSignedDate: 'CD Signed',
  appraisalContingency: 'Appraisal Contingency',
  loanContingency: 'Loan Contingency',
  closingContingency: 'Closing Contingency',
  estimatedFundingDate: 'Est. Funding',
  creditExpirationDate: 'Credit Expires',
};

function formatDate(dateStr) {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return dateStr;
  }
}

export default function AriveKeyDatesCard({ keyDates }) {
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  if (!keyDates || Object.keys(keyDates).length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No key dates available</Text>;
  }

  const entries = Object.entries(DATE_LABELS)
    .map(([key, label]) => ({ key, label, value: keyDates[key] }))
    .filter((e) => e.value);

  if (entries.length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No key dates set</Text>;
  }

  return (
    <VStack align="stretch" spacing={1}>
      {entries.map((e) => (
        <HStack key={e.key} justify="space-between">
          <Text fontSize="xs" color={mutedColor}>{e.label}</Text>
          <Text fontSize="xs" fontWeight="medium">{formatDate(e.value)}</Text>
        </HStack>
      ))}
    </VStack>
  );
}
